<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.paymentDailyReport.paymentDailyReport") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center">
        <div class="flex items-center justify-center sm:justify-evenly xs:justify-evenly flex-wrap">
          <div class="md:ml-4">
            <Listbox as="div" v-model="selected">
              <div class="relative w-48">
                <ListboxButton
                  class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                  <span class="block truncate">{{ selected.label }}</span>
                  <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </span>
                </ListboxButton>

                <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                  leave-to-class="opacity-0">
                  <ListboxOptions
                    class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                    <ListboxOption as="template" v-for="month in months" :key="month.label" :value="month"
                      @click="search(month)">
                      <li :class="[
                        'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                      ]">
                        <span :class="[
                          selected.value == month.value
                            ? 'font-semibold'
                            : 'font-normal',
                          'block truncate text-left',
                        ]">
                          {{ month.label }}
                        </span>

                        <span v-if="selected.value == month.value" :class="[
                          'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                        ]">
                          <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </transition>
              </div>
            </Listbox>
          </div>
          <div class="max-w-lg w-64 lg:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-600 focus-within:text-gray-600">
              <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                {{ $t("messages.paymentDailyReport.from") }}
                :
              </div>
              <input id="from" v-model="fromDate" maxlength="10" @change="searchRage($event)"
                class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                placeholder="From" type="date" name="from" />
            </div>
          </div>
          <div class="max-w-lg w-64 lg:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-600 focus-within:text-gray-600">
              <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                {{ $t("messages.paymentDailyReport.to") }}:
              </div>
              <input id="from" v-model="toDate" maxlength="10" @change="searchRage($event)"
                class="block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                placeholder="To" type="date" name="to" />
            </div>
          </div>
          <!-- <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
            <button type="button" @click="filterModal()"
              class="ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
              <font-awesome-icon class="text-white mr-2" :icon="['far', 'filter']" transform="" />
              {{ $t("messages.userActivityLog.advanceFilter") }}
            </button>
          </div> -->
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
            <button type="button" @click="exports()"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
              <font-awesome-icon class="mr-2" :icon="['far', 'file-export']" />
              {{ $t("messages.paymentDailyReport.exportReport") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center">
        <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
      </div>
    </div>

    <div class="py-6" v-show="isLoaded">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">


            <!-- <table class="table min-w-full divide-y divide-gray-200"> -->
            <div class="p-2">
              <table class="table-fixed min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th></th>
                    <th
                      class="px-3 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer border-2 border-grey-800"
                      :colspan="withdraw.length * subModules.length">Withdraw</th>
                    <th
                      class="px-3 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer border-2 border-grey-800"
                      :colspan="deposit.length * subModules.length">Deposit</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th
                      class="px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer border-2 border-grey-800"
                      :colspan="subModules.length" v-for="item in withdraw">{{ item }}
                    </th>
                    <th
                      class="px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer border-2 border-grey-800"
                      :colspan="subModules.length" v-for="item in deposit">{{ item }}
                    </th>
                  </tr>
                  <tr>
                    <th
                      class="px-3 py-3  text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer border-2 border-grey-800"
                      style="min-width: 140px;">Date</th>
                    <template v-for=" in [...withdraw, ...deposit]">
                      <th v-for="item in subModules"
                        class="px-3 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer border-2 border-grey-800"
                        style="min-width: 140px;">{{ item }}
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="data in dataRows" class="hover:bg-gray-50">
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right border-2 border-grey-800"
                      align="center">{{
                        data.date }}</td>
                    <template v-for="providerWithdraw in withdraw">
                      <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right border-2 border-grey-800"
                        align="center">
                        {{
                          parseFloat(
                            data.withdraw[providerWithdraw]?.amount / 100 || 0
                          ).toLocaleString("en", {
                            useGrouping: true,
                            minimumFractionDigits: 2,
                          })
                        }}
                      </td>
                      <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right border-2 border-grey-800"
                        align="center">
                        {{
                          Number(data.withdraw[providerWithdraw]?.txnCount || 0).toLocaleString("en", {
                            useGrouping: true,
                            minimumFractionDigits: 0,
                          })
                        }}
                      </td>
                      <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right border-2 border-grey-800"
                        align="center">
                        {{
                          Number(data.withdraw[providerWithdraw]?.userCount || 0).toLocaleString("en", {
                            useGrouping: true,
                            minimumFractionDigits: 0,
                          })
                        }}
                      </td>
                    </template>
                    <template v-for="providerDeposit in deposit">
                      <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right border-2 border-grey-800"
                        align="center">
                        {{
                          parseFloat(
                            data.deposit[providerDeposit]?.amount / 100 || 0
                          ).toLocaleString("en", {
                            useGrouping: true,
                            minimumFractionDigits: 2,
                          })
                        }}
                      </td>
                      <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right border-2 border-grey-800"
                        align="center">
                        {{
                          Number(data.deposit[providerDeposit]?.txnCount
                            || 0).toLocaleString("en", {
                              useGrouping: true,
                              minimumFractionDigits: 0,
                            })
                        }}
                      </td>
                      <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right border-2 border-grey-800"
                        align="center">
                        {{
                          Number(data.deposit[providerDeposit]?.userCount
                            || 0).toLocaleString("en", {
                              useGrouping: true,
                              minimumFractionDigits: 0,
                            })
                        }}
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PaymentDailyReportFilterDialog v-model:show="advanceFilterModal" v-model:form="filterForm" @submit="filterModal" />
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import PaymentDailyReportFilterDialog from "@/components/dialogs/PaymentDailyReportFilterDialog.vue";


dayjs.extend(localizedFormat);

const pages = [{ name: "Payment Daily Report", href: "", current: true }];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
    PaymentDailyReportFilterDialog
  },
  setup() {
    const modules = ref(['zpay (module_code)', 'rtb (module_code)', 'sum (module_code)'])
    const subModules = ref(['Amount', 'Txn count', 'User count (distrinct)'])
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toDate = ref("");
    const fromDate = ref("");
    let totals = ref({
      newUser: 0,
      activeUser: 0,
      loggedInUserCount: 0,
      deposit: 0,
      totalBet: 0,
      betAmount: 0,
      validBetAmount: 0,
      bonus: 0,
      winLoss: 0,
      winningPercentage: 0,
      withdraw: 0,
      depositPlayer: 0,
      withdrawPlayer: 0,
      commissionAmount: 0,
      downlineAmount: 0,
      creditAdjustAmount: 0,
      loyalty_redeem_amount: 0,
      loyalty_redeem_count: 0,
    });
    let sortBy = ref([]);

    const startDate = dayjs();
    const diff = startDate.diff("2021-07-01", "months");
    let months = ref([]);
    for (let i = 0; i <= diff; i++) {
      months.value.push({
        label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
        value: dayjs("2021-07-01").add(i, "month").format(),
      });
    }

    months.value.sort((a, b) => (dayjs(b.value).isAfter(dayjs(a.value)) ? 1 : -1));

    const yesterday = {
      label: "Yesterday",
      value: dayjs().add(-1, "day").format(),
    };
    months.value.unshift(yesterday);
    const selected = ref(months.value[0]);

    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);
    const advanceFilterModal = ref(false);
    const filterForm = ref({
      userId: null,
      username: null,
      action: null,
      updatedField: null,
      originalValue: null,
      updatedValue: null,
      from: null,
      to: null,
      status: null,
    });
    const withdraw = ref([])
    const deposit = ref([])

    onMounted(() => {
      refetch();
      setHeader();
    });

    const filterModal = (flag = 0) => {
      advanceFilterModal.value = !advanceFilterModal.value;
      if (flag == 1) {
        refetch();
      }
    };

    const setHeader = () => {
      let providerWithdraw = []
      let providerDeposit = []

      dataRows.value.map((date) => {
        for (const key in date.withdraw) {
          providerWithdraw.push(key)
        }
        for (const key in date.deposit) {
          providerDeposit.push(key)
        }
      })
      providerWithdraw.push("sum")
      providerDeposit.push("sum")

      providerWithdraw = [...new Set(providerWithdraw)]
      providerDeposit = [...new Set(providerDeposit)]
      modules.value = providerWithdraw
      withdraw.value = providerWithdraw
      deposit.value = providerDeposit
      isLoaded.value = true;

    }

    const refetch = () => {
      const {
        moduleCode, operatorId, depositCount, depositAmount, withdrawCount, withdrawAmount
      } = filterForm.value;

      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();

      if (selected.value.label == "Yesterday") {
        fromParams = dayjs(selected.value.value)
          .hour(0)
          .minute(0)
          .second(0)
          .format();
        toParams = dayjs(selected.value.value)
          .hour(23)
          .minute(59)
          .second(59)
          .format();
      }

      const params = {
        from: fromParams, to: toParams, moduleCode, operatorId: store.state.selectedOperator.operatorId, depositCount, depositAmount, withdrawCount, withdrawAmount, sort: [["date", "DESC"]] /*force to show lastes date*/
      }
      axios.get(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/report/operator-payment/daily`, {
        params
      })
        .then(({ data }) => {
          console.log("data: ", data)
          // dataRows.value = formattedData(data)
          // isLoaded.value = true;
              // dataRows.value = data.result;
          // console.log("data search: ", data)
          dataCount.value = 0;
          dataRows.value = formattedData(data)
          isLoaded.value = true;
          setHeader();

        })
        .catch(({ response }) => {
          isLoaded.value = true;
          console.log(response.data);
        });

      // console.log("providerWithdraw: ", [...new Set(providerWithdraw)])
      // console.log("providerDeposit: ", [...new Set(providerDeposit)])
    };

    const formattedData = (data) => {
      console.log('formattedData: ',data)
      return data.result.reduce((acc, record) => {
        const dateIndex = acc.findIndex(item => item.date === record.date);
        const withdrawObj = {
          [record.moduleCode.toLowerCase()]: {
            amount: record.withdrawAmount,
            txnCount: record.withdrawCount,
            userCount: record.withdrawUserCount
          }
        };

        const depositObj = {
          [record.moduleCode.toLowerCase()]: {
            amount: record.depositAmount,
            txnCount: record.depositCount,
            userCount: record.depositUserCount
          }
        };

        if (dateIndex > -1) {
          // Update existing entry
          acc[dateIndex].withdraw = { ...withdrawObj, ...acc[dateIndex].withdraw };
          acc[dateIndex].deposit = { ...depositObj, ...acc[dateIndex].deposit };

          // Update sums
          acc[dateIndex].withdraw.sum.amount += record.withdrawAmount;
          acc[dateIndex].withdraw.sum.txnCount += record.withdrawCount;
          acc[dateIndex].withdraw.sum.userCount += record.withdrawUserCount;

          acc[dateIndex].deposit.sum.amount += record.depositAmount;
          acc[dateIndex].deposit.sum.txnCount += record.depositCount;
          acc[dateIndex].deposit.sum.userCount += record.depositUserCount;
        } else {
          // Create new entry
          acc.push({
            date: record.date,
            withdraw: {
              ...withdrawObj,
              sum: {
                amount: record.withdrawAmount,
                txnCount: record.withdrawCount,
                userCount: record.withdrawUserCount
              }
            },
            deposit: {
              ...depositObj,
              sum: {
                amount: record.depositAmount,
                txnCount: record.depositCount,
                userCount: record.depositUserCount
              }
            }
          });
        }
        return acc;
      }, []);
    }
    const search = (option) => {
      let fromParams = dayjs(option.value).startOf("month").format();
      let toParams = dayjs(option.value).endOf("month").format();
      if (option.label == "Yesterday") {
        fromParams = dayjs(option.value).hour(0).minute(0).second(0).format();
        toParams = dayjs(option.value).hour(23).minute(59).second(59).format();
      }

      isLoaded.value = false;
      axios.get(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/report/operator-payment/daily`, {
        params: {
          operatorId: store.state.selectedOperator.operatorId,
          from: fromParams,
          to: toParams,
          sort: [["date", "DESC"]] /*force to show lastes date*/
        }
      })
        .then(({ data }) => {
          // dataRows.value = data.result;
          console.log("data search: ", data)
          dataCount.value = 0;
          isLoaded.value = true;
          dataRows.value = formattedData(data)
          setHeader();

        })
        .catch((err) => {
          console.log(err);
          isLoaded.value = true;
        });


    };


    const prev = () => {
      if (route.query.page && route.query.page !== "1") {
        router
          .push({
            query: {
              page: parseInt(route.query.page) - 1,
            },
          })
          .then(() => {
            refetch();
          });
      }
    };

    const next = () => {
      router
        .push({
          query: {
            page: parseInt(route.query.page) + 1 || 2,
          },
        })
        .then(() => {
          refetch();
        });
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    const searchRage = (e) => {
      let from = dayjs(fromDate.value).hour(0).minute(0).second(0);
      let to = dayjs(toDate.value).hour(23).minute(59).second(59);
      if (
        (e.code == "Enter" ||
          e.code == "NumpadEnter" ||
          e.type == "change" ||
          e.keyCode == 13) &&
        from.isValid() &&
        to.isValid() &&
        from.isBefore(to)
      ) {
        isLoaded.value = false;
        axios.get(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/report/operator-payment/daily`, {
          params: {
            operatorId: store.state.selectedOperator.operatorId,
            from: from.format(),
            to: to.format(),
            sort: [["date", "DESC"]] /*force to show lastes date*/
          }
        })
          .then(({ data }) => {
            dataRows.value = formattedData(data)
            setHeader()
            dataCount.value = 0;
            isLoaded.value = true;
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      }
    };

    const doSort = (attName) => {
      if (sortBy.value[0] && sortBy.value[0][0] == attName) {
        sortBy.value[0][1] = sortBy.value[0][1] * -1;
      } else {
        sortBy.value = [[attName, -1]];
      }

      let attr_float_name = [
        "id",
        "audit_trial"
      ];
      dataRows.value = dataRows.value.sort((a, b) => {
        let fa = a[attName],
          fb = b[attName];

        if (attr_float_name.includes(attName)) {
          fa = parseFloat(fa);
          fb = parseFloat(fb);
        }

        if (sortBy.value[0][1] == -1) {
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
        } else {
          if (fa > fb) {
            return -1;
          }
          if (fa < fb) {
            return 1;
          }
        }

        return 0;
      });

      isLoaded.value = true;
    };

    const exports = () => {
      let fromParams, toParams
      if (fromDate.value || toDate.value) {
        fromParams = fromDate.value
            ? dayjs(fromDate.value).format()
            : dayjs(selected.value.value).startOf("month").format();
        toParams = toDate.value
            ? dayjs(toDate.value).endOf('day').format()
            : dayjs().endOf('day').format();
      }else if(selected.value.label == "Yesterday"){
        fromParams = dayjs(selected.value.value)
            .hour(0)
            .minute(0)
            .second(0)
            .format();
        toParams = dayjs(selected.value.value)
            .hour(23)
            .minute(59)
            .second(59)
            .format();
      }else{
        fromParams = fromDate.value
            ? dayjs(fromDate.value).format()
            : dayjs(selected.value.value).startOf("month").format();
        toParams = toDate.value
            ? dayjs(toDate.value).endOf('day').format()
            : dayjs(selected.value.value).endOf("month").endOf('day').format();
      }
      axios.get(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/report/export/operator-payment/daily`, {
        params: {
          operatorId: store.state.selectedOperator.operatorId,
          from: fromParams,
          to: toParams,
          sort: [["date", "DESC"]]
        }
      })
        .then(({ data }) => {
          window.open(data.result);
        });


    };

    return {
      dataRows,
      dataCount,
      totals,
      isLoaded,
      dayjs,
      selected,
      toDate,
      route,
      prev,
      next,
      search,
      viewData,
      months,
      pages,
      searchRage,
      fromDate,
      doSort,
      exports,
      filterModal,
      advanceFilterModal,
      filterForm,
      withdraw,
      deposit,
      subModules,
      modules
    };
  },
};
</script>